import axiosInstance, { getNewCancelToken } from '@/services/_AxiosInstance';

const urlBase = '/master/landmark';

const landmarks = {
  get(config) {
    return axiosInstance.get(urlBase, {
      ...config,
      cancelToken: getNewCancelToken(),
    });
  },
  getById(id, config) {
    return axiosInstance.get(`${urlBase}/${id}`, {
      ...config,
      cancelToken: getNewCancelToken(),
    });
  },
  nearest({ latitude, longitude }, config) {
    return axiosInstance.get(`${urlBase}/nearest`, {
      ...config,
      params: { latitude, longitude },
      cancelToken: getNewCancelToken(),
    });
  },
  locate({ latitude, longitude, radius }, config) {
    const params = { latitude, longitude };
    if (radius !== undefined && radius !== null) params.radius = radius;
    return axiosInstance.get(`${urlBase}/locate`, {
      ...config, params, cancelToken: getNewCancelToken(),
    });
  },
  area({
    minLatitude, maxLatitude, minLongitude, maxLongitude,
  }, config) {
    return axiosInstance.get(`${urlBase}/area`, {
      ...config,
      params: {
        minLatitude,
        maxLatitude,
        minLongitude,
        maxLongitude,
      },
      cancelToken: getNewCancelToken(),
    });
  },
  create(data) {
    return axiosInstance.post(urlBase, data, {
      cancelToken: getNewCancelToken(),
    });
  },
  delete(id, config) {
    return axiosInstance.delete(`${urlBase}/${id}`, {
      ...config,
      cancelToken: getNewCancelToken(),
    });
  },
  update(id, data, config) {
    return axiosInstance.put(`${urlBase}/${id}`, data, {
      ...config,
      cancelToken: getNewCancelToken(),
    });
  },
};

export default {
  landmarks,
};
